//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
let d=[[],[],[]];
SPLM.Features.AECDesign.RebarsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.RebarsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.RebarsBuilder.CrossingCreationMethod = Object.freeze({
    "Rectangular" : "Rectangular", "CylindricalSpiral" : "CylindricalSpiral", "CylindricalCircular" : "CylindricalCircular"});

SPLM.Features.AECDesign.RebarsBuilder.LongitudinalCreationMethod = Object.freeze({
    "WithinRectangular" : "WithinRectangular", "WithinCylindrical" : "WithinCylindrical", "OnPoint" : "OnPoint"});

SPLM.Features.AECDesign.RebarsBuilder.LimitOption = Object.freeze({
    "Value" : "Value", "SymmetricValue" : "SymmetricValue", "UntilNext" : "UntilNext", "UntilSelected" : "UntilSelected", "UntilExtended" : "UntilExtended", "OffsetFromSelected" : "OffsetFromSelected"});

SPLM.Features.AECDesign.RebarsBuilder.SpacingOption = Object.freeze({
    "EquallyDistributed" : "EquallyDistributed", "ExactSpacing" : "ExactSpacing", "ExactSpacingFirst" : "ExactSpacingFirst", "ExactSpacingLast" : "ExactSpacingLast", "ExactSpacingMiddle" : "ExactSpacingMiddle", "ExactSpacingFirstAndLast" : "ExactSpacingFirstAndLast"});

SPLM.Features.AECDesign.RebarsBuilder.PatternOption = Object.freeze({
    "FourBarAround" : "FourBarAround", "SixBarsMirrored" : "SixBarsMirrored", "EightBarsAround" : "EightBarsAround", "EightBarsMirrored" : "EightBarsMirrored", "TenBarsMirrored" : "TenBarsMirrored", "TwelveBarsMirrored" : "TwelveBarsMirrored"});

SPLM.Features.AECDesign.RebarsBuilder.HookOption = Object.freeze({
    "None" : "None", "Degrees90" : "Degrees90", "Degrees135" : "Degrees135", "Degrees180" : "Degrees180", "UserDefined" : "UserDefined"});

SPLM.Features.AECDesign.RebarsBuilder.HookOffsetOption = Object.freeze({
    "CoverThickness" : "CoverThickness", "UserDefined" : "UserDefined"});

export default SPLM;